module.exports = __webpack_public_path__ + "img/BW_workflow_diagram.a0c35fa2.png";